/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../libs/graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RouteBuilderSavedRoutesQueryVariables = Types.Exact<{
  metropolisId: Types.Scalars['Int']['input']
  filter?: Types.InputMaybe<Types.SavedRouteFilterInput>
}>

export type RouteBuilderSavedRoutesQuery = {
  __typename?: 'Query'
  savedRoutes: Array<{
    __typename?: 'SavedRoute'
    id: string
    name: string
    description: string
    metroId: number
    tripType: Types.TripType
    isArchived: boolean
    distance: number
    createdMs: number
    updatedMs: number
    createdById: string
    updatedById: string
    assignedVtrs: Array<{
      __typename?: 'AssignedVtr'
      vtr: string
      codebeamerIds: Array<string>
    }>
  }>
}

export type RouteBuilderSavedRouteDetailsForMapQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input']
}>

export type RouteBuilderSavedRouteDetailsForMapQuery = {
  __typename?: 'Query'
  savedRouteDetails: {
    __typename?: 'SavedRouteDetails'
    id: string
    trip: {
      __typename?: 'TmpTrip'
      segments: Array<{
        __typename?: 'TripSegmentWithStatus'
        segment: {
          __typename?: 'TripSegment'
          id: string
          sequenceId: number
          metadata: Array<Array<string>>
          destination: {
            __typename?: 'TripGeolocation'
            latitude: number
            longitude: number
          } | null
          stop: {
            __typename?: 'TripDestination'
            desiredAddress: string
            desiredLocation: {
              __typename?: 'TripGeolocation'
              latitude: number
              longitude: number
              heading: number
            } | null
          } | null
          route: {
            __typename?: 'TripRoute'
            coordinates: Array<{
              __typename?: 'TripGeolocation'
              latitude: number
              longitude: number
            }>
          } | null
        } | null
      }>
    } | null
  } | null
}

export type RouteBuilderSavedTripsByVtrsQueryVariables = Types.Exact<{
  associatedVtrs:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input']
}>

export type RouteBuilderSavedTripsByVtrsQuery = {
  __typename?: 'Query'
  savedTripsByVtrs: Array<{
    __typename?: 'SavedTripsByVtrEntry'
    vtr: string
    savedTrips: Array<{
      __typename?: 'SavedTripEntry'
      id: string
      name: string
    }>
  }>
}

export type RouteBuilderBackofficeUserByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type RouteBuilderBackofficeUserByIdQuery = {
  __typename?: 'Query'
  backofficeUserById:
    | {
        __typename?: 'BackofficeUser'
        id: string
        firstName: string
        lastName: string
      }
    | { __typename?: 'BackofficeUserLimited' }
}

export type RouteBuilderMetropolisesQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type RouteBuilderMetropolisesQuery = {
  __typename?: 'Query'
  metropolises: Array<{
    __typename?: 'Metropolis'
    id: string
    name: string
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  }>
}

export type RouteBuilderAssignSavedTripMutationVariables = Types.Exact<{
  savedTripId: Types.Scalars['String']['input']
  vin: Types.Scalars['String']['input']
}>

export type RouteBuilderAssignSavedTripMutation = {
  __typename?: 'Mutation'
  assignSavedTrip: { __typename?: 'TmpTrip'; id: string; vin: string } | null
}

export type RouteBuilderDispatchingStatusQueryVariables = Types.Exact<{
  savedTripId: Types.Scalars['String']['input']
  vin: Types.Scalars['String']['input']
}>

export type RouteBuilderDispatchingStatusQuery = {
  __typename?: 'Query'
  dispatchingStatus: {
    __typename?: 'DispatchedTrip'
    savedTripId: string
    vin: string
    metroId: number
    dispatchingStatus: Types.DispatchingStatus
    lastDispatchingStatusMs: number
  } | null
}

export type RouteBuilderSetSavedTripArchivedMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input']
  isArchived: Types.Scalars['Boolean']['input']
}>

export type RouteBuilderSetSavedTripArchivedMutation = {
  __typename?: 'Mutation'
  setSavedTripArchived: {
    __typename?: 'SavedTripEntry'
    id: string
    isArchived: boolean
  } | null
}

export const RouteBuilderSavedRoutesDocument = gql`
    query RouteBuilderSavedRoutes($metropolisId: Int!, $filter: SavedRouteFilterInput) {
  savedRoutes(metroId: $metropolisId, filter: $filter) {
    id
    name
    description
    metroId
    tripType
    isArchived
    distance
    createdMs
    updatedMs
    createdById
    updatedById
    assignedVtrs {
      vtr
      codebeamerIds
    }
  }
}
    `

/**
 * __useRouteBuilderSavedRoutesQuery__
 *
 * To run a query within a React component, call `useRouteBuilderSavedRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderSavedRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderSavedRoutesQuery({
 *   variables: {
 *      metropolisId: // value for 'metropolisId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRouteBuilderSavedRoutesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  > &
    (
      | { variables: RouteBuilderSavedRoutesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  >(RouteBuilderSavedRoutesDocument, options)
}
export function useRouteBuilderSavedRoutesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  >(RouteBuilderSavedRoutesDocument, options)
}
// @ts-ignore
export function useRouteBuilderSavedRoutesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRoutesQuery,
  RouteBuilderSavedRoutesQueryVariables
>
export function useRouteBuilderSavedRoutesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRoutesQuery,
        RouteBuilderSavedRoutesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRoutesQuery | undefined,
  RouteBuilderSavedRoutesQueryVariables
>
export function useRouteBuilderSavedRoutesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRoutesQuery,
        RouteBuilderSavedRoutesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderSavedRoutesQuery,
    RouteBuilderSavedRoutesQueryVariables
  >(RouteBuilderSavedRoutesDocument, options)
}
export type RouteBuilderSavedRoutesQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRoutesQuery
>
export type RouteBuilderSavedRoutesLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRoutesLazyQuery
>
export type RouteBuilderSavedRoutesSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRoutesSuspenseQuery
>
export type RouteBuilderSavedRoutesQueryResult = Apollo.QueryResult<
  RouteBuilderSavedRoutesQuery,
  RouteBuilderSavedRoutesQueryVariables
>
export const RouteBuilderSavedRouteDetailsForMapDocument = gql`
    query RouteBuilderSavedRouteDetailsForMap($id: String!) {
  savedRouteDetails(routeId: $id) {
    id
    trip {
      segments {
        segment {
          id
          sequenceId
          metadata
          destination {
            latitude
            longitude
          }
          stop {
            desiredLocation {
              latitude
              longitude
              heading
            }
            desiredAddress
          }
          route {
            coordinates {
              latitude
              longitude
            }
          }
        }
      }
    }
  }
}
    `

/**
 * __useRouteBuilderSavedRouteDetailsForMapQuery__
 *
 * To run a query within a React component, call `useRouteBuilderSavedRouteDetailsForMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderSavedRouteDetailsForMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderSavedRouteDetailsForMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteBuilderSavedRouteDetailsForMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  > &
    (
      | {
          variables: RouteBuilderSavedRouteDetailsForMapQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  >(RouteBuilderSavedRouteDetailsForMapDocument, options)
}
export function useRouteBuilderSavedRouteDetailsForMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  >(RouteBuilderSavedRouteDetailsForMapDocument, options)
}
// @ts-ignore
export function useRouteBuilderSavedRouteDetailsForMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRouteDetailsForMapQuery,
  RouteBuilderSavedRouteDetailsForMapQueryVariables
>
export function useRouteBuilderSavedRouteDetailsForMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRouteDetailsForMapQuery,
        RouteBuilderSavedRouteDetailsForMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedRouteDetailsForMapQuery | undefined,
  RouteBuilderSavedRouteDetailsForMapQueryVariables
>
export function useRouteBuilderSavedRouteDetailsForMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedRouteDetailsForMapQuery,
        RouteBuilderSavedRouteDetailsForMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderSavedRouteDetailsForMapQuery,
    RouteBuilderSavedRouteDetailsForMapQueryVariables
  >(RouteBuilderSavedRouteDetailsForMapDocument, options)
}
export type RouteBuilderSavedRouteDetailsForMapQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRouteDetailsForMapQuery
>
export type RouteBuilderSavedRouteDetailsForMapLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedRouteDetailsForMapLazyQuery
>
export type RouteBuilderSavedRouteDetailsForMapSuspenseQueryHookResult =
  ReturnType<typeof useRouteBuilderSavedRouteDetailsForMapSuspenseQuery>
export type RouteBuilderSavedRouteDetailsForMapQueryResult = Apollo.QueryResult<
  RouteBuilderSavedRouteDetailsForMapQuery,
  RouteBuilderSavedRouteDetailsForMapQueryVariables
>
export const RouteBuilderSavedTripsByVtrsDocument = gql`
    query RouteBuilderSavedTripsByVtrs($associatedVtrs: [String!]!) {
  savedTripsByVtrs(associatedVtrs: $associatedVtrs) {
    vtr
    savedTrips {
      id
      name
    }
  }
}
    `

/**
 * __useRouteBuilderSavedTripsByVtrsQuery__
 *
 * To run a query within a React component, call `useRouteBuilderSavedTripsByVtrsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderSavedTripsByVtrsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderSavedTripsByVtrsQuery({
 *   variables: {
 *      associatedVtrs: // value for 'associatedVtrs'
 *   },
 * });
 */
export function useRouteBuilderSavedTripsByVtrsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  > &
    (
      | {
          variables: RouteBuilderSavedTripsByVtrsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  >(RouteBuilderSavedTripsByVtrsDocument, options)
}
export function useRouteBuilderSavedTripsByVtrsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  >(RouteBuilderSavedTripsByVtrsDocument, options)
}
// @ts-ignore
export function useRouteBuilderSavedTripsByVtrsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedTripsByVtrsQuery,
  RouteBuilderSavedTripsByVtrsQueryVariables
>
export function useRouteBuilderSavedTripsByVtrsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedTripsByVtrsQuery,
        RouteBuilderSavedTripsByVtrsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderSavedTripsByVtrsQuery | undefined,
  RouteBuilderSavedTripsByVtrsQueryVariables
>
export function useRouteBuilderSavedTripsByVtrsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderSavedTripsByVtrsQuery,
        RouteBuilderSavedTripsByVtrsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderSavedTripsByVtrsQuery,
    RouteBuilderSavedTripsByVtrsQueryVariables
  >(RouteBuilderSavedTripsByVtrsDocument, options)
}
export type RouteBuilderSavedTripsByVtrsQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedTripsByVtrsQuery
>
export type RouteBuilderSavedTripsByVtrsLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedTripsByVtrsLazyQuery
>
export type RouteBuilderSavedTripsByVtrsSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderSavedTripsByVtrsSuspenseQuery
>
export type RouteBuilderSavedTripsByVtrsQueryResult = Apollo.QueryResult<
  RouteBuilderSavedTripsByVtrsQuery,
  RouteBuilderSavedTripsByVtrsQueryVariables
>
export const RouteBuilderBackofficeUserByIdDocument = gql`
    query RouteBuilderBackofficeUserById($id: ID!) {
  backofficeUserById(id: $id) {
    ... on BackofficeUser {
      id
      firstName
      lastName
    }
  }
}
    `

/**
 * __useRouteBuilderBackofficeUserByIdQuery__
 *
 * To run a query within a React component, call `useRouteBuilderBackofficeUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderBackofficeUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderBackofficeUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRouteBuilderBackofficeUserByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  > &
    (
      | {
          variables: RouteBuilderBackofficeUserByIdQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  >(RouteBuilderBackofficeUserByIdDocument, options)
}
export function useRouteBuilderBackofficeUserByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  >(RouteBuilderBackofficeUserByIdDocument, options)
}
// @ts-ignore
export function useRouteBuilderBackofficeUserByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderBackofficeUserByIdQuery,
  RouteBuilderBackofficeUserByIdQueryVariables
>
export function useRouteBuilderBackofficeUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderBackofficeUserByIdQuery,
        RouteBuilderBackofficeUserByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderBackofficeUserByIdQuery | undefined,
  RouteBuilderBackofficeUserByIdQueryVariables
>
export function useRouteBuilderBackofficeUserByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderBackofficeUserByIdQuery,
        RouteBuilderBackofficeUserByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderBackofficeUserByIdQuery,
    RouteBuilderBackofficeUserByIdQueryVariables
  >(RouteBuilderBackofficeUserByIdDocument, options)
}
export type RouteBuilderBackofficeUserByIdQueryHookResult = ReturnType<
  typeof useRouteBuilderBackofficeUserByIdQuery
>
export type RouteBuilderBackofficeUserByIdLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderBackofficeUserByIdLazyQuery
>
export type RouteBuilderBackofficeUserByIdSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderBackofficeUserByIdSuspenseQuery
>
export type RouteBuilderBackofficeUserByIdQueryResult = Apollo.QueryResult<
  RouteBuilderBackofficeUserByIdQuery,
  RouteBuilderBackofficeUserByIdQueryVariables
>
export const RouteBuilderMetropolisesDocument = gql`
    query RouteBuilderMetropolises {
  metropolises {
    id
    name
    location: origin {
      latitude
      longitude
    }
  }
}
    `

/**
 * __useRouteBuilderMetropolisesQuery__
 *
 * To run a query within a React component, call `useRouteBuilderMetropolisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderMetropolisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderMetropolisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRouteBuilderMetropolisesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >(RouteBuilderMetropolisesDocument, options)
}
export function useRouteBuilderMetropolisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >(RouteBuilderMetropolisesDocument, options)
}
// @ts-ignore
export function useRouteBuilderMetropolisesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderMetropolisesQuery,
  RouteBuilderMetropolisesQueryVariables
>
export function useRouteBuilderMetropolisesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderMetropolisesQuery,
        RouteBuilderMetropolisesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderMetropolisesQuery | undefined,
  RouteBuilderMetropolisesQueryVariables
>
export function useRouteBuilderMetropolisesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderMetropolisesQuery,
        RouteBuilderMetropolisesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderMetropolisesQuery,
    RouteBuilderMetropolisesQueryVariables
  >(RouteBuilderMetropolisesDocument, options)
}
export type RouteBuilderMetropolisesQueryHookResult = ReturnType<
  typeof useRouteBuilderMetropolisesQuery
>
export type RouteBuilderMetropolisesLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderMetropolisesLazyQuery
>
export type RouteBuilderMetropolisesSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderMetropolisesSuspenseQuery
>
export type RouteBuilderMetropolisesQueryResult = Apollo.QueryResult<
  RouteBuilderMetropolisesQuery,
  RouteBuilderMetropolisesQueryVariables
>
export const RouteBuilderAssignSavedTripDocument = gql`
    mutation RouteBuilderAssignSavedTrip($savedTripId: String!, $vin: String!) {
  assignSavedTrip(savedTripId: $savedTripId, vin: $vin) {
    id
    vin
  }
}
    `
export type RouteBuilderAssignSavedTripMutationFn = Apollo.MutationFunction<
  RouteBuilderAssignSavedTripMutation,
  RouteBuilderAssignSavedTripMutationVariables
>

/**
 * __useRouteBuilderAssignSavedTripMutation__
 *
 * To run a mutation, you first call `useRouteBuilderAssignSavedTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderAssignSavedTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderAssignSavedTripMutation, { data, loading, error }] = useRouteBuilderAssignSavedTripMutation({
 *   variables: {
 *      savedTripId: // value for 'savedTripId'
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useRouteBuilderAssignSavedTripMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderAssignSavedTripMutation,
    RouteBuilderAssignSavedTripMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderAssignSavedTripMutation,
    RouteBuilderAssignSavedTripMutationVariables
  >(RouteBuilderAssignSavedTripDocument, options)
}
export type RouteBuilderAssignSavedTripMutationHookResult = ReturnType<
  typeof useRouteBuilderAssignSavedTripMutation
>
export type RouteBuilderAssignSavedTripMutationResult =
  Apollo.MutationResult<RouteBuilderAssignSavedTripMutation>
export type RouteBuilderAssignSavedTripMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderAssignSavedTripMutation,
    RouteBuilderAssignSavedTripMutationVariables
  >
export const RouteBuilderDispatchingStatusDocument = gql`
    query RouteBuilderDispatchingStatus($savedTripId: String!, $vin: String!) {
  dispatchingStatus(savedTripId: $savedTripId, vin: $vin) {
    savedTripId
    vin
    metroId
    dispatchingStatus
    lastDispatchingStatusMs
  }
}
    `

/**
 * __useRouteBuilderDispatchingStatusQuery__
 *
 * To run a query within a React component, call `useRouteBuilderDispatchingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderDispatchingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderDispatchingStatusQuery({
 *   variables: {
 *      savedTripId: // value for 'savedTripId'
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useRouteBuilderDispatchingStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  > &
    (
      | {
          variables: RouteBuilderDispatchingStatusQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  >(RouteBuilderDispatchingStatusDocument, options)
}
export function useRouteBuilderDispatchingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  >(RouteBuilderDispatchingStatusDocument, options)
}
// @ts-ignore
export function useRouteBuilderDispatchingStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderDispatchingStatusQuery,
  RouteBuilderDispatchingStatusQueryVariables
>
export function useRouteBuilderDispatchingStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderDispatchingStatusQuery,
        RouteBuilderDispatchingStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderDispatchingStatusQuery | undefined,
  RouteBuilderDispatchingStatusQueryVariables
>
export function useRouteBuilderDispatchingStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderDispatchingStatusQuery,
        RouteBuilderDispatchingStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderDispatchingStatusQuery,
    RouteBuilderDispatchingStatusQueryVariables
  >(RouteBuilderDispatchingStatusDocument, options)
}
export type RouteBuilderDispatchingStatusQueryHookResult = ReturnType<
  typeof useRouteBuilderDispatchingStatusQuery
>
export type RouteBuilderDispatchingStatusLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderDispatchingStatusLazyQuery
>
export type RouteBuilderDispatchingStatusSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderDispatchingStatusSuspenseQuery
>
export type RouteBuilderDispatchingStatusQueryResult = Apollo.QueryResult<
  RouteBuilderDispatchingStatusQuery,
  RouteBuilderDispatchingStatusQueryVariables
>
export const RouteBuilderSetSavedTripArchivedDocument = gql`
    mutation RouteBuilderSetSavedTripArchived($id: String!, $isArchived: Boolean!) {
  setSavedTripArchived(id: $id, isArchived: $isArchived) {
    id
    isArchived
  }
}
    `
export type RouteBuilderSetSavedTripArchivedMutationFn =
  Apollo.MutationFunction<
    RouteBuilderSetSavedTripArchivedMutation,
    RouteBuilderSetSavedTripArchivedMutationVariables
  >

/**
 * __useRouteBuilderSetSavedTripArchivedMutation__
 *
 * To run a mutation, you first call `useRouteBuilderSetSavedTripArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderSetSavedTripArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeBuilderSetSavedTripArchivedMutation, { data, loading, error }] = useRouteBuilderSetSavedTripArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useRouteBuilderSetSavedTripArchivedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RouteBuilderSetSavedTripArchivedMutation,
    RouteBuilderSetSavedTripArchivedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RouteBuilderSetSavedTripArchivedMutation,
    RouteBuilderSetSavedTripArchivedMutationVariables
  >(RouteBuilderSetSavedTripArchivedDocument, options)
}
export type RouteBuilderSetSavedTripArchivedMutationHookResult = ReturnType<
  typeof useRouteBuilderSetSavedTripArchivedMutation
>
export type RouteBuilderSetSavedTripArchivedMutationResult =
  Apollo.MutationResult<RouteBuilderSetSavedTripArchivedMutation>
export type RouteBuilderSetSavedTripArchivedMutationOptions =
  Apollo.BaseMutationOptions<
    RouteBuilderSetSavedTripArchivedMutation,
    RouteBuilderSetSavedTripArchivedMutationVariables
  >
